import introSection from './_intro_section';
import prozent_100 from './_prozent_section';

import paranussbaum from './_paranussbaum';
import anleitung from './_anleitung';
import eineuro from './_eineuro';
import gpsData from './_gps_data';
import achievements from './_achievements';
import download from './_download';

import gaEventHanlder from './_ga_event';

document.addEventListener('DOMContentLoaded', () => {
  introSection();
  prozent_100();
  paranussbaum();
  anleitung();
  eineuro();
  gpsData();
  achievements();
  download();

  // allinoneTest();

  const progressBar = document.getElementById('abw_progress');

  window.addEventListener('scroll', () => {
    let scrollTop = window.scrollY;
    let docHeight = document.body.offsetHeight;
    let winHeight = window.innerHeight;
    let scrollPercent = scrollTop / (docHeight - winHeight);

    progressBar.value = scrollPercent * 100;
  });

  gaEventHanlder();
});
